import { render } from "./FeaturePanel.vue?vue&type=template&id=38d2f133&scoped=true"
import script from "./FeaturePanel.vue?vue&type=script&lang=js"
export * from "./FeaturePanel.vue?vue&type=script&lang=js"

import "./FeaturePanel.vue?vue&type=style&index=0&id=38d2f133&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d2f133"]])

export default __exports__